/* This file is autogenerated, see readme.md for instructions */
import GoToSvgIcon from '@bloomreach/banana-theme/icons/go-to.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const GoToIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <GoToSvgIcon />
    </Icon>
  );
});

GoToIcon.displayName = 'GoToIcon';

export default GoToIcon;
